export default function Menu() {
	// Mobile menu functionality
	const mobileMenuToggle = document.querySelector('.mobile-menu-toggle')
	const navMenu = document.querySelector('.nav-menu')
	const dropdownItems = document.querySelectorAll('.has-dropdown')

	function closeMenuOnClickLink() {
		const links = document.querySelectorAll('.nav-menu a')

		links.forEach((link) => {
			link.addEventListener('click', (event) => {
				const parentLi = link.closest('li')

				// Se for dropdown e tiver href="#" (não leva a outra página), não fecha o menu
				if (parentLi?.classList.contains('has-dropdown') && link.getAttribute('href') === '#') {
					event.preventDefault() // impede o scroll pro topo
					return
				}

				// Caso contrário, fecha o menu
				mobileMenuToggle.classList.remove('active')
				navMenu.classList.remove('active')
			})
		})
	}

	// Toggle mobile menu
	mobileMenuToggle.addEventListener('click', () => {
		mobileMenuToggle.classList.toggle('active')
		navMenu.classList.toggle('active')
	})

	// Handle dropdown toggles on mobile
	dropdownItems.forEach((item) => {
		const link = item.querySelector('a')

		// For mobile: toggle dropdowns on click
		link.addEventListener('click', (e) => {
			if (window.innerWidth <= 1024) {
				e.preventDefault()
				item.classList.toggle('active')
			}
		})
	})

	// Close mobile menu when clicking outside
	document.addEventListener('click', (e) => {
		if (!navMenu.contains(e.target) && !mobileMenuToggle.contains(e.target)) {
			mobileMenuToggle.classList.remove('active')
			navMenu.classList.remove('active')
			dropdownItems.forEach((item) => item.classList.remove('active'))
		}
	})

	// Handle window resize
	window.addEventListener('resize', () => {
		if (window.innerWidth > 1024) {
			mobileMenuToggle.classList.remove('active')
			navMenu.classList.remove('active')
			dropdownItems.forEach((item) => item.classList.remove('active'))
		}
	})

	closeMenuOnClickLink()
}
